import { useLocation } from "react-router";
import { useMemo } from "react";
import { HistoryEntry } from "../api";

type TableName = HistoryEntry["table"];

export function useTableNameFromUrl(): TableName | null {
  const { pathname } = useLocation();

  return useMemo<TableName | null>(() => {
    const segment = pathname.split("/").filter(Boolean)[0];
    switch (segment) {
      case "kontrakty":
      case "towar-do-zabrania":
        return "Contract";
      case "zlecenia-transportowe":
        return "TransportOrder";
      case "spedycja":
        return "ForwardingOrder";
      case "kierowca":
        return "Driver";
      case "lokalizacje":
        return "Location";
      case "firmy":
        return "Company";
      case "towar":
        return "Product";
      case "dostawy":
        // Deliveries are a view - table name is determined from row data
        return null;
      default:
        return null;
    }
  }, [pathname]);
}
